// import logo from './logo.svg';
// import nl from './nl';
import React   from 'react';
import './App.css';
import Row from './Row'
import requests from './Requests';
import './Row.css';
import './Ap.css';
import Banner from './Banner';
// import './Banner.css';
import Nav from './Nav';

function App() {
  return (
    <div className="App">
      
      {/* <h1>Hey I'm Anand And I'M bulid Netflix Clone</h1> */}
     <Nav/>
      <Banner/>
      <Row title="NETFLIX ORIGINALS" fetchUrl = {requests.fetchNetflixOriginals} isLargeRow = {true}
       />
      
      <Row title="Trending Now" fetchUrl={requests.fetchTrending}/>
      {/* <Row title="Top Rated" fetchUrl={requests.fetchTopRated}/> */}
      <Row title="Action Movies" fetchUrl={requests.fetchActionMovies}/>
      <Row title="Comedy Movies" fetchUrl={requests.fetchComedyMovies}/>
      <Row title="Horror Movies" fetchUrl={requests.fetchHorrorMovies}/>
      <Row title="Romentic Movies" fetchUrl={requests.fetchRomenticMovies}/>
      <Row title="Documentries Movies" fetchUrl={requests.fetchDocumentries}/>

    </div>
  );
}

export default App;
 